import script from "./AllAnimalsRanking.vue?vue&type=script&setup=true&lang=js"
export * from "./AllAnimalsRanking.vue?vue&type=script&setup=true&lang=js"

import "./AllAnimalsRanking.vue?vue&type=style&index=0&id=150b6a8b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-150b6a8b"]])

export default __exports__